import { render } from "./Locaties.vue?vue&type=template&id=1e5bdeb4"
import script from "./Locaties.vue?vue&type=script&lang=js"
export * from "./Locaties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__